<template>
    <div class="billing-center-box">
        <van-nav-bar title="账单中心" />
        <div>
            <van-cell title="已售出优惠券账单" is-link to="/welfare-related?isSold=true" value="" />
            <van-cell title="已核销优惠券账单" is-link to="/write-off?isSold=false" value="" />
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        onClickLeft() {
            this.$router.go(-1);
        }
    }
};
</script>

<style scoped lang="scss"></style>
